import script from "./ContactUsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsForm.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsForm.vue?vue&type=style&index=0&id=8c282a74&lang=scss"

const __exports__ = script;

export default __exports__